import * as React from "react"

import { Button, Stack, TextField, Typography } from "@mui/material"

import { LoadingButton } from "@mui/lab"
import { useTranslation } from "react-i18next"

interface IPropmptBoxProps {
  title: string
  description?: string
  onSubmit: (values?: { name: string }) => void
  onClose: () => void
  cancelButtonText?: string
  acceptButtonText?: string
  loadingSubmit?: boolean
  showNameField?: boolean
  nameFieldLabel?: string
  defaultName?: string
}

const PropmptBox: React.FunctionComponent<IPropmptBoxProps> = ({
  title,
  description,
  onSubmit,
  onClose,
  cancelButtonText,
  acceptButtonText,
  loadingSubmit = false,
  showNameField = false,
  nameFieldLabel,
  defaultName = ""
}) => {
  const { t } = useTranslation("common")
  const [name, setName] = React.useState(defaultName)

  const handleSubmit = () => {
    if (showNameField) {
      onSubmit({ name: name.trim() })
    } else {
      onSubmit()
    }
  }

  return (
    <Stack direction="column" sx={{ p: 2 }} spacing={3}>
      <Typography component="strong" variant="h6">
        {title}
      </Typography>
      {description && <Typography component="span">{description}</Typography>}
      {showNameField && (
        <TextField
          label={nameFieldLabel || "Name"}
          value={name}
          onChange={(e) => setName(e.target.value)}
          fullWidth
          autoFocus
        />
      )}
      <Stack direction="row" spacing={1}>
        <Button onClick={onClose} variant="outlined" color="error">
          {cancelButtonText || t("cancel")}
        </Button>
        <LoadingButton
          loading={loadingSubmit}
          onClick={handleSubmit}
          disabled={showNameField && !name.trim()}
          variant="contained"
          color="error"
          sx={{ width: 120, maxWidth: "100%" }}
        >
          {acceptButtonText || t("submit")}
        </LoadingButton>
      </Stack>
    </Stack>
  )
}

export default PropmptBox
